import { createSlice } from "@reduxjs/toolkit";
import { getNotesList } from "../../reduxApi/admin/NotesReduxApi";

const noteSlice = createSlice({
    name: 'note',
    initialState: {
        status: 'idel',
        isFiltered: false,
        note: [],
    },
    reducers: {
        setFilteredStatus: (state, action) => {
            state.isFiltered = action.payload;
        },
        deleteNoteAction: (state, action) => {
            action.payload.forEach((id) => {
                const index = state.note.findIndex((item) => item.ROWID === id);
                if (index !== -1) {
                    state.note.splice(index, 1);
                }
            });
        },
        updateNoteAction: (state, action) => {
            const index = state.note.findIndex((item) => item.ROWID === action.payload.ROWID)
            if (index != -1) {
                state.note.splice(index, 1, { notes: action.payload })
            }
        },
        addNoteAction: (state, action) => {
            console.log("action--->",action.payload);
            
            const temp = action.payload;
            console.log("temp",temp)
            temp.ROWID = action.payload.ROWID;
            console.log("temp.ROWID",temp.ROWID);
            
            state.note.unshift({ notes: temp }); //add new data at beginning of array 
        }
    },
    extraReducers: (builder) => {
        builder.addCase(getNotesList.pending, (state, action) => {
            state.status = 'pending'
        })
            .addCase(getNotesList.fulfilled, (state, action) => {
                state.status = 'fulfilled'
                state.note = action.payload.data.notes;
            })
    }
})
export const { deleteNoteAction, updateNoteAction, addNoteAction, setFilteredStatus } = noteSlice.actions
export default noteSlice.reducer